"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Shelf = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _useCursor2 = require("use-cursor");

var _visuallyDisableScrollbar = require("../../helpers/visuallyDisableScrollbar");

var _Box = require("../Box");

var _Carousel = require("../Carousel");

var _FullBleed = require("../FullBleed");

var _ShelfNavigation = require("./ShelfNavigation");

var _ShelfScrollBar = require("./ShelfScrollBar");

var _excluded = ["alignItems", "showProgress", "snap", "children", "onChange"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 * A Shelf is a new kind of carousel...
 */


var Shelf = function Shelf(_ref) {
  var _ref$alignItems = _ref.alignItems,
      alignItems = _ref$alignItems === void 0 ? "flex-end" : _ref$alignItems,
      _ref$showProgress = _ref.showProgress,
      showProgress = _ref$showProgress === void 0 ? true : _ref$showProgress,
      _ref$snap = _ref.snap,
      snap = _ref$snap === void 0 ? "none" : _ref$snap,
      children = _ref.children,
      onChange = _ref.onChange,
      rest = _objectWithoutProperties(_ref, _excluded);

  var cells = (0, _react.useMemo)(function () {
    return _react.Children.toArray(children).filter(_react.isValidElement).map(function (child) {
      return {
        child: child,
        ref: /*#__PURE__*/(0, _react.createRef)()
      };
    });
  }, [children]);
  var containerRef = (0, _react.useRef)(null);
  var viewportRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      mounted = _useState2[0],
      setMounted = _useState2[1];

  var _useState3 = (0, _react.useState)([0]),
      _useState4 = _slicedToArray(_useState3, 2),
      pages = _useState4[0],
      setPages = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = _slicedToArray(_useState5, 2),
      offset = _useState6[0],
      setOffset = _useState6[1];

  var _useState7 = (0, _react.useState)(true),
      _useState8 = _slicedToArray(_useState7, 2),
      atStart = _useState8[0],
      setAtStart = _useState8[1];

  var init = (0, _react.useCallback)(function () {
    if (containerRef.current === null) return;
    var container = containerRef.current; // Set page-stops

    var values = cells.map(function (_ref2, i) {
      var ref = _ref2.ref; // If we have an offset we actually want to subtract it from
      // the first and last elements.

      if (offset !== 0 && (i === 0 || i === cells.length - 1)) {
        return Math.ceil(ref.current.clientWidth - offset);
      }

      return ref.current.clientWidth;
    });
    setPages((0, _Carousel.paginateCarousel)({
      // Here we use the container width instead of the viewport width.
      // The viewport has been extended to the full width of the window;
      // we want to scroll to the parent boundaries instead.
      viewport: container.clientWidth,
      values: values
    })); // Set offset to accomodate full-bleed and line up initially with page-margins

    var _container$getBoundin = container.getBoundingClientRect(),
        x = _container$getBoundin.x;

    setOffset(x);
    setMounted(true);
  }, [cells, offset]);
  (0, _react.useEffect)(function () {
    init();
    window.addEventListener("resize", init);
    return function () {
      window.removeEventListener("resize", init);
    };
  }, [init]);

  var _useCursor = (0, _useCursor2.useCursor)({
    max: pages.length
  }),
      pageIndex = _useCursor.index,
      setCursor = _useCursor.setCursor; // Keep page cursor in sync with scroll position


  (0, _react.useEffect)(function () {
    if (viewportRef.current === null) return;
    var viewport = viewportRef.current;

    var handler = function handler() {
      var nearestPage = pages.find(function (currentPage, i) {
        var _pages;

        var nextPage = (_pages = pages[i + 1]) !== null && _pages !== void 0 ? _pages : Infinity;
        return viewport.scrollLeft >= currentPage && viewport.scrollLeft < nextPage;
      });
      setCursor(pages.indexOf(nearestPage));
      setAtStart(viewport.scrollLeft === 0);
    };

    viewport.addEventListener("scroll", handler, {
      passive: true
    });
    return function () {
      viewport.removeEventListener("scroll", handler);
    };
  }, [pages, setCursor]); // Announce page changes

  (0, _react.useEffect)(function () {
    onChange && onChange(pageIndex);
  }, [onChange, pageIndex]); // Scroll to a specific page-stop

  var scrollToPage = function scrollToPage(index) {
    var xPosition = pages[index];
    scrollTo(xPosition);
  };

  var scrollTo = function scrollTo(xPosition) {
    if (viewportRef.current === null) return;
    var viewport = viewportRef.current;

    if (viewport.scrollTo) {
      viewport.scrollTo({
        left: xPosition,
        behavior: "smooth"
      });
      return;
    }

    viewport.scrollLeft = xPosition;
  }; // One side-effect of scrolling to the next page index instead of
  // setting it directly is that you can't scroll to the next one via click until
  // you've arrived. We may want to reconsider this approach; though this is the
  // simplest way to keep these values in sync with one another.


  var handleNext = function handleNext() {
    scrollToPage(pageIndex + 1);
  };

  var handlePrev = function handlePrev() {
    if (pageIndex === 0) {
      scrollTo(0);
      return;
    }

    scrollToPage(pageIndex - 1);
  };

  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    ref: containerRef
  }, rest), /*#__PURE__*/_react.default.createElement(Nav, {
    as: "nav" // We can't position relative to the FullBleed rail —
    // so offset the bottom by the bottom margin + the height of the scrollbar.
    ,
    bottom: [23, 63]
  }, /*#__PURE__*/_react.default.createElement(Previous, {
    onClick: handlePrev,
    disabled: atStart,
    "aria-label": "Previous page"
  }), /*#__PURE__*/_react.default.createElement(Next, {
    onClick: handleNext,
    disabled: pageIndex === pages.length - 1,
    "aria-label": "Next page"
  })), /*#__PURE__*/_react.default.createElement(_FullBleed.FullBleed // To prevent any page jank we initially partially disable this component
  // so that content is left aligned with the parent container and then once
  // we have the offset and page values; we reset it to actually full-bleed.
  // The `offset` will push the content up to the parent margin.
  , !mounted ? {
    left: null,
    right: null,
    marginLeft: null
  } : {}, /*#__PURE__*/_react.default.createElement(Viewport, {
    ref: viewportRef
  }, /*#__PURE__*/_react.default.createElement(Rail, {
    as: "ul",
    position: "relative",
    alignItems: alignItems,
    mb: [2, 6]
  }, cells.map(function (_ref3, i) {
    var child = _ref3.child,
        ref = _ref3.ref;
    var isFirst = i === 0;
    var isLast = i === cells.length - 1;
    return /*#__PURE__*/_react.default.createElement(Cell, {
      as: "li",
      key: i,
      ref: ref,
      pl: isFirst ? offset : undefined,
      pr: !isLast ? _Carousel.CELL_GAP_PADDING_AMOUNT : offset,
      style: {
        scrollSnapAlign: snap
      }
    }, child);
  })))), showProgress && /*#__PURE__*/_react.default.createElement(_ShelfScrollBar.ShelfScrollBar, {
    viewport: viewportRef.current
  }));
};

exports.Shelf = Shelf;
Shelf.displayName = "Shelf";
var Container = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Shelf__Container",
  componentId: "sc-1kdkue-0"
})(["position:relative;width:100%;> nav{transition:opacity 250ms;transition-delay:100ms;opacity:0;}&:hover{> nav{opacity:1;}}"]);
var Nav = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Shelf__Nav",
  componentId: "sc-1kdkue-1"
})(["pointer-events:none;position:absolute;z-index:1;top:0;right:0;left:0;"]);
var Viewport = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Shelf__Viewport",
  componentId: "sc-1kdkue-2"
})(["display:flex;height:100%;padding:0;list-style:none;overflow-y:hidden;overflow-x:scroll;-webkit-overflow-scrolling:touch;scroll-snap-type:x mandatory;", ""], _visuallyDisableScrollbar.visuallyDisableScrollbar);
var Rail = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Shelf__Rail",
  componentId: "sc-1kdkue-3"
})(["display:flex;width:100%;height:100%;margin-top:0;margin-left:0;margin-right:0;padding:0;list-style:none;white-space:nowrap;"]);
var Cell = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Shelf__Cell",
  componentId: "sc-1kdkue-4"
})(["white-space:normal;"]);
var Next = (0, _styledComponents.default)(_ShelfNavigation.ShelfNext).withConfig({
  displayName: "Shelf__Next",
  componentId: "sc-1kdkue-5"
})(["position:absolute;top:50%;transform:translateY(-50%);right:0;@media (hover:none){display:none;}"]);
var Previous = (0, _styledComponents.default)(_ShelfNavigation.ShelfPrevious).withConfig({
  displayName: "Shelf__Previous",
  componentId: "sc-1kdkue-6"
})(["position:absolute;top:50%;transform:translateY(-50%);left:0;@media (hover:none){display:none;}"]);